import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllChanelPartnerData } from "reduxStore/action/webReportActions";
import { getAllProperty } from "reduxStore/action/propertyActions";
import strings from "translate/language";
import { handleListResponse } from "utils/utils";
import Select from "react-select";
import Breadcrumb from "component/common/breadcrumb";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import moment from "moment";
import ExcelJS from "exceljs";

const ChanelPartnerReport = ({ isAuth = false }) => {
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [propertyList, setPropertyList] = useState();
  const [cpReportData, setCpReportData] = useState(null);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [expandedRows, setExpandedRows] = useState({});
  const todayDate = new Date().toISOString().split("T")[0];
  const [form, setForm] = useState({
    property_title: "",
    cp_name: "",
    start_date: todayDate,
    end_date: todayDate,
  });
  const [loading, setLoading] = useState(true);
  const cpReportDatas = useSelector(
    (state) => state.webreport.getAllChanelPartnerData
  );
  const propertySelector = useSelector((state) => state.propertyData);

  useEffect(() => {
    dispatch(getAllChanelPartnerData({}));
    dispatch(getAllProperty());
  }, [dispatch]);

  useEffect(() => {
    const { response } = propertySelector;
    if (response?.status === 200) {
      setPropertyList(handleListResponse(response.data));
    } else {
      setPropertyList([]);
    }
  }, [propertySelector]);

  useEffect(() => {
    if (cpReportDatas?.data) {
      setCpReportData(cpReportDatas.data);
      setLoading(false);
    }
  }, [cpReportDatas]);

  const handleSelectChange = (selectedOption) => {
    setForm({
      ...form,
      property_title: selectedOption ? selectedOption.value : "",
    });
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (
      (form.start_date && !form.end_date) ||
      (!form.start_date && form.end_date)
    ) {
      formError = true;
      err["date"] = strings.startEndDateErr;
    }

    setFormVaild(err);
    return formError;
  };

  const filterDetail = () => {
    if (!handleValid()) {
      setLoading(true);
      dispatch(getAllChanelPartnerData({ ...form }));
    }
  };

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  const filterReset = () => {
    setForm({
      property_title: "",
      cp_name: "",
      start_date: todayDate,
      end_date: todayDate,
    });
    setLoading(true);
    dispatch(getAllChanelPartnerData([]));
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    setFormVaild({ ...formVaild, [e.target.name]: "" });
  };

  const toggleExpand = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // const exportToExcel = async () => {
  //   if (!cpReportData || cpReportData.length === 0) {
  //     alert("No data to export");
  //     return;
  //   }

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("ChannelPartnerReport");

  //   worksheet.columns = [
  //     { header: "CP Name", key: "cpName", width: 20 },
  //     { header: "Created Date", key: "createdDate", width: 20 },
  //     { header: "RERA Certificate No", key: "reraCertificateNo", width: 20 },
  //     { header: "Mobile No", key: "mobileNo", width: 15 },
  //     { header: "Location", key: "location", width: 20 },
  //     { header: "Pincode", key: "pincode", width: 10 },
  //     { header: "Allocated Property", key: "allocatedProperty", width: 25 },
  //     { header: "Booking Count", key: "bookingCount", width: 15 },
  //     { header: "Visitor Count", key: "visitorCount", width: 15 },
  //     { header: "Walk-In Count", key: "walkInCount", width: 15 },
  //   ];

  //   cpReportData.forEach((cp) => {
  //     const projects = cp.allocated_projects || [];

  //     if (projects.length === 0) {
  //       // If no project, still export one row with blank project info
  //       worksheet.addRow({
  //         cpName: cp.agent_name || "N/A",
  //         createdDate: cp.createdDate ? moment(cp.createdDate).format("DD-MM-yyyy hh:mm a") : "N/A",
  //         reraCertificateNo: cp.rera_certificate_no || "N/A",
  //         mobileNo: cp.primary_mobile || "N/A",
  //         location: cp.location || "N/A",
  //         pincode: cp.pin_code || "N/A",
  //         allocatedProperty: "N/A",
  //         bookingCount: 0,
  //         visitorCount: 0,
  //         walkInCount: 0,
  //       });
  //     } else {
  //       // Export each project in a new row
  //       projects.forEach((project) => {
  //         worksheet.addRow({
  //           cpName: cp.agent_name || "N/A",
  //           createdDate: cp.createdDate ? moment(cp.createdDate).format("DD-MM-yyyy hh:mm a") : "N/A",
  //           reraCertificateNo: cp.rera_certificate_no || "N/A",
  //           mobileNo: cp.primary_mobile || "N/A",
  //           location: cp.location || "N/A",
  //           pincode: cp.pin_code || "N/A",
  //           allocatedProperty: project.property_title || "N/A",
  //           bookingCount: project.booking_count || 0,
  //           visitorCount: project.visitor_count || 0,
  //           walkInCount: project.walk_in_count || 0,
  //         });
  //       });
  //     }
  //   });

  //   const buffer = await workbook.xlsx.writeBuffer();

  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = "Channel_Partner_Report.xlsx";
  //   link.click();
  // };

  const exportToExcel = async () => {
    if (!cpReportData || cpReportData.length === 0) {
      alert("No data to export");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("ChannelPartnerReport");

    worksheet.columns = [
      { header: "Sr.No", key: "sno", width: 6 },
      { header: "Created Date & Time", key: "createdDate", width: 20 },
      { header: "Channel Partner Name", key: "cpName", width: 20 },
      { header: "RERA Certificate No", key: "reraCertificateNo", width: 20 },
      { header: "Mobile No", key: "mobileNo", width: 15 },
      { header: "Location", key: "location", width: 20 },
      { header: "Pincode", key: "pincode", width: 10 },
      { header: "Allocated Property", key: "allocatedProperty", width: 25 },
      { header: "Visitor Count", key: "visitorCount", width: 15 },
      { header: "Walk-In Count", key: "walkInCount", width: 15 },
      { header: "Booking Count", key: "bookingCount", width: 15 },
    ];

    let serial = 1;

    cpReportData.forEach((cp) => {
      const projects = cp.allocated_projects || [];

      if (projects.length === 0) {
        worksheet.addRow({
          sno: serial++,
          createdDate: cp.createdDate
          ? moment(cp.createdDate).format("DD-MM-yyyy hh:mm a")
          : "N/A",
          cpName: cp.agent_name || "N/A",
          reraCertificateNo: cp.rera_certificate_no || "N/A",
          mobileNo: cp.primary_mobile || "N/A",
          location: cp.location || "N/A",
          pincode: cp.pin_code || "N/A",
          allocatedProperty: "N/A",
          visitorCount: 0,
          walkInCount: 0,
          bookingCount: 0,
        });
      } else {
        projects.forEach((project, pIndex) => {
          worksheet.addRow({
            sno: pIndex === 0 ? serial : "",
            cpName: pIndex === 0 ? cp.agent_name || "N/A" : "",
            createdDate:
              pIndex === 0
                ? cp.createdDate
                  ? moment(cp.createdDate).format("DD-MM-yyyy hh:mm a")
                  : "N/A"
                : "",
            reraCertificateNo:
              pIndex === 0 ? cp.rera_certificate_no || "N/A" : "",
            mobileNo: pIndex === 0 ? cp.primary_mobile || "N/A" : "",
            location: pIndex === 0 ? cp.location || "N/A" : "",
            pincode: pIndex === 0 ? cp.pin_code || "N/A" : "",
            allocatedProperty: project.property_title || "N/A",
            visitorCount: project.visitor_count || 0,
            walkInCount: project.walk_in_count || 0,
            bookingCount: project.booking_count || 0,
          });
        });
        serial++;
      }
    });

    worksheet.getRow(1).font = { bold: true };

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Channel_Partner_Report.xlsx";
    link.click();
  };

  return (
    <div className="page-body">
      {isAuth && (
        <Breadcrumb
          title={strings.getAllChanelPartnerData}
          parentListing={null}
          titleactive={strings.getAllChanelPartnerDataListing}
        />
      )}

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <form className="theme-form">
                <div className="row">
                  {/* Start Date */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <label className="form-label">{strings.startDate}</label>
                    <input
                      className="form-control"
                      type="date"
                      name="start_date"
                      value={form.start_date}
                      onChange={handleInputField}
                    />
                    {formVaild.start_date && (
                      <small className="text-danger">
                        {formVaild.start_date}
                      </small>
                    )}
                  </div>

                  {/* End Date */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <label className="form-label">{strings.endDate}</label>
                    <input
                      className="form-control"
                      type="date"
                      name="end_date"
                      value={form.end_date}
                      onChange={handleInputField}
                      min={form.start_date}
                      disabled={endDateDisable}
                    />
                    {formVaild.end_date && (
                      <small className="text-danger">
                        {formVaild.end_date}
                      </small>
                    )}
                  </div>

                  {/* Property Name */}
                  <div className="col-lg-4 col-md-12 mb-3">
                    <label className="form-label">{strings.propertyName}</label>
                    <Select
                      isDisabled={!propertyList || propertyList.length === 0}
                      classNamePrefix="select"
                      isSearchable
                      isClearable
                      options={
                        propertyList
                          ? propertyList.map((property) => ({
                              value: property.property_title,
                              label: property.property_title,
                            }))
                          : []
                      }
                      value={
                        form.property_title
                          ? {
                              label: form.property_title,
                              value: form.property_title,
                            }
                          : null
                      }
                      onChange={handleSelectChange}
                      placeholder="Select property"
                    />
                  </div>

                  {/* Search by Name */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <label className="form-label">{strings.searchByName}</label>
                    <input
                      className="form-control"
                      type="text"
                      name="cp_name"
                      value={form.cp_name}
                      onChange={handleInputField}
                      placeholder={strings.searchName}
                      autoComplete="off"
                    />
                  </div>

                  {/* Action Buttons */}
                  <div className="col-lg-8 col-md-6 mb-3 d-flex align-items-end justify-content-end">
                    <div>
                      <button
                        className="btn btn-warning mr-4 me-2"
                        type="button"
                        onClick={filterDetail}
                      >
                        {strings.submit}
                      </button>
                      <button
                        className="btn btn-dark"
                        type="button"
                        onClick={filterReset}
                      >
                        {strings.reset}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {cpReportData && cpReportData.length > 0 ? (
            <div className="d-flex justify-content-end mr-4">
              <button className="btn btn-primary" onClick={exportToExcel}>
                Export to Excel
              </button>
            </div>
          ) : null}

          <hr />
          <div className="row">
            <div className="col-sm-12 col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h5>{strings.listOfChannelPartner}</h5>
                </div>
                <div className="table-responsive">
                  {cpReportData && cpReportData.length > 0 ? (
                    <table
                      className="table table-bordered table-hover"
                      style={{
                        minWidth: "1700px",
                        tableLayout: "fixed",
                      }}
                    >
                      <thead className="text-center align-middle">
                        <tr>
                          <th style={{ width: "4%", padding: "8px 10px" }}>
                            Sr. No.
                          </th>
                          <th style={{ width: "10%", padding: "8px 10px" }}>
                            {strings.createdDateTime}
                          </th>
                          <th style={{ width: "12%", padding: "8px 10px", textAlign:"left", }}>
                            {strings.channelPartnerName}
                          </th>
                          <th style={{ width: "10%", padding: "8px 10px", textAlign:"right" }}>
                            {strings.reraCertificateNo}
                          </th>
                          <th style={{ width: "10%", padding: "8px 10px" }}>
                            {strings.mobileNo}
                          </th>
                          <th style={{ width: "8%", padding: "8px 10px", textAlign:"left", }}>
                            {strings.location}
                          </th>
                          <th style={{ width: "8%", padding: "8px 10px" }}>
                            {strings.pincode}
                          </th>
                          <th style={{ width: "14%", padding: "8px 10px", textAlign:"left", }}>
                            {strings.allocateProperty}
                          </th>
                          <th style={{ width: "6%", padding: "8px 10px" }}>
                            {strings.AllocatedProjecVisitorCount}
                          </th>
                          <th style={{ width: "6%", padding: "8px 10px" }}>
                            {strings.AllocatedProjecWalkInCount}
                          </th>
                          <th style={{ width: "6%", padding: "8px 10px" }}>
                            {strings.AllocatedProjecbookingCount}
                          </th>
                          <th style={{ width: "6%", padding: "8px 10px" }}>
                            View
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-center align-middle">
                        {cpReportData.map((cp, index) => {
                          const isExpanded = expandedRows[index];
                          const projects = cp.allocated_projects || [];
                          const firstProject = projects[0];
                          const remainingProjects = projects.slice(1);

                          return (
                            <React.Fragment key={index}>
                              <tr>
                                 <td
                                  style={{
                                    width: "10%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    textAlign:"right",
                                  }}
                                >
                                  {index + 1}
                                </td>
                                    <td
                                      style={{
                                        width: "12%",
                                        padding: "8px 10px",
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {cp.createdDate
                                        ? moment(cp.createdDate).format(
                                            "DD-MM-yyyy hh:mm a"
                                          )
                                        : "N/A"}
                                    </td>
                                <td
                                  style={{
                                    width: "10%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    textAlign:"left",
                                  }}
                                >
                                  {cp.agent_name || "N/A"}
                                </td>
                                <td
                                  style={{
                                    width: "12%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {cp.rera_certificate_no || "N/A"}
                                </td>
                                <td
                                  style={{
                                    width: "10%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {cp.primary_mobile || "N/A"}
                                </td>
                                <td
                                  style={{
                                    width: "18%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    textAlign:"left",
                                  }}
                                >
                                  {cp.location || "N/A"}
                                </td>
                                <td
                                  style={{
                                    width: "6%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {cp.pin_code || "N/A"}
                                </td>
                                <td
                                  style={{
                                    width: "20%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    textAlign:"left",
                                  }}
                                >
                                  {firstProject?.property_title || "N/A"}
                                </td>
                                <td
                                  style={{
                                    width: "8%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {firstProject?.visitor_count || 0}
                                </td>
                                <td
                                  style={{
                                    width: "8%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {firstProject?.walk_in_count || 0}
                                </td>
                                <td
                                  style={{
                                    width: "8%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {firstProject?.booking_count || 0}
                                </td>
                                <td
                                  style={{
                                    width: "4%",
                                    padding: "8px 10px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                >
                                  {projects.length > 1 && (
                                    <button
                                      onClick={() => toggleExpand(index)}
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        backgroundColor: "#ffffff",
                                        border: "1px solid #d1d5db",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease-in-out",
                                        boxShadow:
                                          "0 1px 2px rgba(0, 0, 0, 0.05)",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                          "#e3e1e1";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                          "#ffffff";
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#4b5563",
                                          fontSize: "16px",
                                          transition: "transform 0.3s ease",
                                          transform: isExpanded
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {isExpanded ? (
                                          <FaChevronUp />
                                        ) : (
                                          <FaChevronDown />
                                        )}
                                      </span>
                                    </button>
                                  )}
                                </td>
                              </tr>

                              {isExpanded &&
                                remainingProjects.map((project, pIndex) => (
                                  <tr key={`${index}-${pIndex}`}
                                  style={{
                                        width: "8%",
                                        padding: "8px 10px",
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                        backgroundColor: "#f2f2f2",
                                        textAlign:"left",
                                      }}>
                                    <td colSpan="7"></td>
                                    <td>
                                      {project.property_title || "N/A"}
                                    </td>
                                    <td style={{textAlign:"center",}}>
                                      {project.visitor_count || 0}
                                    </td>
                                    <td style={{textAlign:"center",}}>
                                      {project.walk_in_count || 0}
                                    </td>
                                    <td style={{textAlign:"center",}}>
                                      {project.booking_count || 0}
                                    </td>
                                    <td></td>
                                  </tr>
                                ))}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center text-black p-3">
                      No data found
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChanelPartnerReport;
